'use strict'

export default {
  methods: {
    pickNumber(value) {
      let stringValue = `${value}`.replace(/\./g, '')
      if (/^\d+(|,){1}\d+$/.test(stringValue) || /^\d+$/.test(stringValue)) {
        return parseInt(stringValue)
      }
      return null
    },
    pickFloat(value) {
      let stringValue = `${value}`.replace(/\./g, '')
      if (/^\d+(|,){1}\d+$/.test(stringValue) || /^\d+$/.test(stringValue)) {
        return parseFloat(stringValue).toFixed(2)
      }
      return null
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/FormMixin.js